<template>
  <div class="container">
     <div class="background-overlay"></div> 
    <div class="info-box">
      <h1 class="title">Tax Calculation Information</h1>

      <p class="intro">
        At <strong>Tax Engine</strong>, we simplify complex tax calculations for tobacco
        products across all U.S. states. Our system ensures accuracy and compliance by
        using predefined tax formulas tailored to state regulations and product
        categories. Below is an overview of the tax calculation methods used in our
        application.
      </p>

      <div class="section">
        <h2 class="section-title">Tax Formulas Used in the Application</h2>

        <ul class="formula-list">
          <li>
            <strong>Milliliter Liquid Tax:</strong> Applied to milliliter liquid
            <span class="formula"
              >Formula: tax =   LSU_factor * LSU_volume * Tax_per_unit</span
            
            >
          </li>
          <li>
            <strong>Cost Price Tax:</strong> Calculated based on the product's cost price.
            <span class="formula"
              >Formula: tax = cost_price * (tax_percentage / 100)</span
            >
          </li>
          <li>
            <strong>Sales Price Tax:</strong> Applied based on the product's final selling
            price.
            <span class="formula"
              >Formula: tax = sales_price * (tax_percentage / 100)</span
            >
          </li>
          <li>
            <strong>LSU Factor Tax:</strong> Uses LSU (Legally Standardized Unit) factors
            to determine tax values.
            <span class="formula">Formula: tax = LSU_factor * Tax_per_unit</span>
          </li>
          <li>
            <strong>Per Pack Tax:</strong> Applied per pack, based on volume and LSU
            factor.
            <span class="formula"
              >Formula: tax =  LSU_factor * LSU_weight * Tax_per_unit</span
             
            >
          </li>
        </ul>
      </div>

      <div class="section">
        <h2 class="section-title">How Our Tax Calculation Works</h2>
        <ul class="info-list">
          <li>
            The application fetches state-wise tax rules and applies the appropriate
            formula based on the tobacco product category.
          </li>
          <li>
            Users can calculate taxes in real time or upload bulk data using a CSV file
            for automated processing.
          </li>
          <li>
            Our system ensures compliance by dynamically selecting the correct formula
            depending on the product type and state regulations.
          </li>
          <li>
            Every calculation is precise, ensuring businesses and individuals receive
            accurate tax values for their tobacco-related transactions.
          </li>
        </ul>
      </div>

      <p class="closing">
        At <strong>Tax Engine</strong>, we make tax computation effortless and
        transparent, helping you stay compliant with ease.
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
html,
body {
  min-height: 100vh;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.background-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background:
    linear-gradient(135deg, rgba(15, 32, 39, 0.85), rgba(32, 58, 67, 0.85), rgba(44, 83, 100, 0.85)),
    url('../assets/images/usstate.jpg') no-repeat center;
 background-size: cover;
  filter: blur;
  z-index: -1;
  pointer-events: none;
}
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  width: 100%;
}

.info-box {
  width: 85%;
  max-width: 100%;
  background: #cbd8f0;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
}

.title {
  text-align: center;
  font-size: 30px;
  color: #2c3e50;
  margin-bottom: 20px;
  font-weight: bold;
}

.intro,
.closing {
  font-size: 16px;
  text-align: center;
  color: #555;
  line-height: 1.6;
}

.section {
  margin-top: 25px;
}

.section-title {
  font-size: 22px;
  color: #34495e;
  border-left: 5px solid #3498db;
  padding-left: 12px;
  margin-bottom: 15px;
  font-weight: bold;
}

.formula-list,
.info-list {
  list-style: none;
  padding: 0;
}

.formula-list li,
.info-list li {
  background: #f8f9fa;
  padding: 14px;
  margin: 10px 0;
  border-radius: 10px;
  font-size: 16px;
  color: #2c3e50;
  transition: transform 0.2s ease-in-out;
}

.formula-list li:hover,
.info-list li:hover {
  background: #e3e9ed;
  transform: translateY(3px);
}

.formula {
  display: block;
  font-size: 14px;
  color: #e74c3c;
  margin-top: 5px;
  font-weight: bold;
}
</style>
